<template>
  <div>
    <div class="container">
      <logo-and-nav :nav-list="navList"/>
      <img class="news-banner" src="/imgs/news-banner.jpg" />
      <div class="content-container">
        <news-nav class="nav" :title="newsNav.name" :list="newsNav.children" :is-list="true"/>
        <news-item class="news-list"/>
      </div>
    </div>

    <div class="bottom-wrapper">
      <global-bottom />
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import LogoAndNav from '@/components/LogoAndNav'
import NewsNav from '@/components/NewsNav'
import NewsItem from '@/components/NewsItem'
import GlobalBottom from '@/components/GlobalBottom'
import { requestUrl, orgId } from '../common/constant'

export default {
  name: 'NewsList',
  components: {
    LogoAndNav,
    NewsNav,
    NewsItem,
    GlobalBottom
  },
  data () {
    return {
      navList: [],
      newsNav: {},
      columnId: ''
    }
  },
  async mounted () {
    this.columnId = this.$route.params.id
    await this.queryNavList()
  },
  methods: {
    async queryNavList () {
      // 获取头部导航
      const navs = await axios.get(`${requestUrl}/nav/${orgId}`)
      // 获取子栏目列表
      const columns = await axios.get(`${requestUrl}/news/getChannelList?id=${this.columnId}`)
      // 去掉头部导航中 网上办公栏目
      navs.data.forEach(item => {
        if (item.title === '网上办公') {
        } else this.navList.push(item)
      })
      this.newsNav = columns.data[0]
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.news-banner {
  width: 100%;
  height: 180px;
}

.content-container {
  display: flex;
  justify-content: space-between;
  width: 1190px;
  margin-top: 10px;
}

.bottom-wrapper {
  margin-top: 50px;
}

</style>
